import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=49695fb0&scoped=true"
import script from "./Domains.vue?vue&type=script&lang=js"
export * from "./Domains.vue?vue&type=script&lang=js"
import style0 from "./Domains.vue?vue&type=style&index=0&id=49695fb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49695fb0",
  null
  
)

export default component.exports